module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter_1#ch1"
    }
  }, [_vm._v("Chapter 1 – The First Air War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 – Things Get Serious")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 – The Fokker’s Day")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 – Fokker Aces Supreme")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 – Knights of the Air")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 – Nieuport Scouts")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 – Autumn Chill")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-c"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 – The End of 1916")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 63
// module chunks = 0